<template>
  <div >
    <form-header :pageTitle="'菜单功能管理'" @save="save('ruleForm')" style="margin: 0 20px;"></form-header>
    <div class="white-bg-radius role-setting w-label">
      <!--<el-row>-->
        <!--<el-col :span="8">-->
          <div class="left-menu">
            <SearchCheckTree
              :placeholderSearchText="'菜单名称搜索'"
              :dialog-visible="true"
              :initCheckKey="ruleForm.parentId "
              :expand-on-click-node="false"
              @node-click="clickMenu"
              :showCheckbox="false"
              :data="menuData"
              :default-props="defaultMenuProps"
              :defaultExpandAll="true"
            ></SearchCheckTree>
          </div>
        <!--</el-col>-->
        <!--<el-col :span="16">-->
          <div class="right-form ww-form">
              <el-form :model="ruleForm" :rules="rules" ref="form"
                       label-position="right" label-width="130px" class="demo-ruleForm">
                <p class="title">菜单信息</p>
                <el-form-item label="菜单功能分类：" prop="menuType">
                  <el-select v-model="ruleForm.menuType" :disabled="disabled">
                    <el-option label="文件夹样式类菜单" :value="1" ></el-option>
                    <el-option label="数据展示类菜单" :value="2"></el-option>
                    <el-option label="功能按钮":value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上级菜单名称：" prop="parentId">
                  <el-input v-model="ruleForm.parentName" :readonly="true"  placeholder="上级菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="功能名称：" prop="menuName">
                  <el-input v-model="ruleForm.menuName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="URL：" prop="url">
                  <el-input v-model="ruleForm.url" placeholder="请输入url"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                  <el-input v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="排序：" prop="sort">
                  <el-input-number v-model="ruleForm.sort" :controls="true" ></el-input-number>
                </el-form-item>

                <!--<el-form-item label="状态：" prop="state">-->
                  <!--<el-radio-group v-model="ruleForm.state">-->
                    <!--<el-radio :label="0">有效</el-radio>-->
                    <!--<el-radio :label="1">无效</el-radio>-->
                  <!--</el-radio-group>-->
                <!--</el-form-item>-->
              </el-form>
          </div>
        <!--</el-col>-->
      <!--</el-row>-->

    </div>
  </div>
</template>
<script>
 // import { mapGetters } from 'vuex'
 import formHeader from '../components/form-header'

 import commonMixin from '@/mixins/common.js'
 import SearchCheckTree from "../components/search-check-tree.vue";
 import { methodPost, methodGet } from '@/api/requestWithMessage'
 const menuUrl = '/sysmenu/findSysMenuTreeList'
 const organizeUrl = '2'
 const getInfoByIdUrl = '/sysmenu/findSysMenuById/'
 const submitUrl = '/sysmenu/saveSysMenu'
 const modifyUrl = '/sysmenu/modifySysMenu'

 export default {
   name: 'index',
   mixins: [commonMixin],
   data() {
     return {
       id: this.$route.query.id,
       permissionTypes: [
         { label: '仅自己', value: '仅自己' },
         { label: '自己及以下', value: '自己及以下' },
         { label: '同级及以下', value: '同级及以下' },
         { label: '全部', value: '全部' },
         { label: '自定义', value: '自定义' }
       ],
       selectMenu: {},
       organizeData: [],
       menuData: [],
       ruleForm: {
         sort: 0,
         menuCode: '',
         menuName: '',
         parentId: '',
         parentName: '',
         url: '',
         menuType: '',
         permissionType: ''
       },
       rules: {
         menuType: [{ required: true, message: "此项为必填项" }],
         menuName: [{ required: true, message: "此项为必填项" }],
         parentId: [{ required: false, message: "请在左侧选择上级菜单" }],
         state: [{ required: false, message: "此项为必填项" }]
       },
       showDialogFlag: true,
       defaultMenuCheckedKeys: [],
       defaultOrganizeKeys: [],
       defaultMenuProps: {
         children: 'children',
         label: 'menuName',
         id: 'id'
       },
       value15: "",
       defaultOrganizeProps: {
         children: 'children',
         label: 'label',
         id: 'id'
       }
     }
   },
   components: {
     SearchCheckTree,
     formHeader
   },
   computed: {
     disabled() {
       return !!this.id
     }
   },
   methods: {
     clickMenu(node) {
       const menu = node.data
       if (menu.menuType === 3) {
         this.$message.error('请选择菜单')
       } else {
         if (menu.id && menu.menuName) {
           this.ruleForm.parentName = menu.menuName
           this.ruleForm.parentId = menu.id
         }
       }
     },
     permissionChange(val) {
       console.log(val)
       if (val === '自定义') {
         this.showDialog()
       } else {
         this.showDialogFlag = false
       }
     },
     back(isRefresh = true) {
       const path = '/config/%2Ftemplate%2Fmodule%2Fsystem%2Fsystem_menu_list.json'
       this.goBack(path)
       if (isRefresh) {
         this.$nextTick(() => {
           this.$bus.$emit('refresh-grid')
         })
       }
     },
     save() {
       this.$refs.form.validate(valid => {
         if (valid) {
           this.submitForm()
         } else {
           console.log('error submit!!')
         }
       })
     },
     submitForm() {
       const param = this.ruleForm
       const url = this.id ? modifyUrl : submitUrl;
       const endStr = '.json'
       const d = this.ruleForm.url.length - '.json'.length;
       const isEndJson = (d >= 0 && this.ruleForm.url.lastIndexOf(endStr) === d);
       if (isEndJson) {
         param['configKey'] = this.ruleForm.url
         param['path'] = ''
       } else {
         param['configKey'] = ''
         param['path'] = this.ruleForm.url
       }
       if (this.id) {
         param['id'] = this.id
       }
       methodPost(url, param).then(res => {
         console.log(res)
         if (res.code === 0) {
           this.back(1)
         } else {
           this.$message.error(res.message || '出错了！')
         }
       }).catch(err => {
         console.error(err)
         this.$message.error(err.message || '出错了！')
       })
     },
     getMenuData() {
       methodPost(menuUrl).then(res => {
         this.menuData = res.data
       })
     },
     getOrganizeData() {
       methodPost(organizeUrl).then(res => {
         this.organizeData = res.data
       })
     },
     resetForm(formName) {
       this.$refs[formName].resetFields()
     },
     // 出现弹框里边的方法
     setSelectItem(val) {
       this.defaultCheckedKeys = val
       this.showDialogFlag = false;
     },
     clear(type) {
     },
     init() {
       if (this.id) {
         methodGet(getInfoByIdUrl + `${this.id}`).then(res => {
           const data = res.data
           this.ruleForm = {
             sort: data.sort,
             menuCode: data.menuCode,
             menuName: data.menuName,
             parentId: data.parentId,
             remark: data.remark || '',
             parentName: data.parentMenuName,
             url: data.path || data.configKey || '',
             menuType: data.menuType,
             permissionType: data.permissionType
           }
         })
       }
       this.getMenuData()

       // this.getOrganizeData()
     },
     // 关闭弹框
     cancel() {
       this.showDialogFlag = false;
     },
     // 显示弹框
     showDialog(e, val) {
       this.showDialogFlag = true;
     }
   },
   mounted() {
   },
   created() {
     this.init()
   }
 }
</script>
<style type="text/scss" lang="scss" scoped>
  .role-setting{
    display: flex;
    .left-menu{
      width: 300px;
      border: solid 1px #f3f3f3;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
    }
    .right-form{
      height: 100%;
      padding-left: 20px;
      .title{
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size:16px;
        font-weight: normal;
      }
      .sub-title{
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
    .no-b-b {
      box-shadow: none;
      border: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/menuManager/index.vue